import React, { FunctionComponent } from 'react';
import SignUpStateForm from '@/components/signUp/SignUpStateForm';
import useSignUpWizard from '@/hooks/useSignUpWizard';
import useCurrentUser from '@jetslash/market-frontend-shared-core/src/hooks/useCurrentUser';

interface IProps {}

const SignUpWizard: FunctionComponent<IProps> = () => {
  const { signUpUser } = useSignUpWizard();
  const { currentUser } = useCurrentUser();

  // This prevents the need to block certain SignUp UX that rely on user sign up state
  const effectiveSignUpUser = signUpUser || currentUser;

  return <SignUpStateForm signUpUser={effectiveSignUpUser} />;
};

export default SignUpWizard;
